module.exports = __webpack_public_path__ + "img/T4-B-rc_9.d8397c22.png";